import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

interface StyledLinkProps {
  children: string
  className?: string
  to: string
  state?: unknown
}

export const StyledLink: React.FC<StyledLinkProps> = ({
  children,
  className,
  to,
  state,
}) => {
  return (
    <Link
      to={to}
      state={state}
      className={classNames('text-primary underline text-lg', className)}
    >
      {children}
    </Link>
  )
}
